export default "__VITE_ASSET__1auHEeHI6St45$3SiNGoNw__"